export default {"src":"/_next/static/media/Credlix-Remit.06c8dd63.svg","height":32,"width":34};